import { createSelector } from "@ngrx/store";
import { PetStateModel } from "./pet.reducer";
import { AppStateModel } from "../app-state.model";

export const selectFeaturePets = (state: AppStateModel) => state.pets;
export const selectPets = createSelector(selectFeaturePets, (state: PetStateModel) => state.pets);
